// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"fb19b9af","703":"0e023c89","849":"f671ec7b"}[chunkId] + ".chunk.js";
};